import { Fetch, ResponseError } from "@lucaswickstrom/fetch";
class MemdbRequest extends Fetch {
    requestOptions;
    constructor(options) {
        super(options);
        this.requestOptions = options;
    }
    set options(options) {
        super.options = options;
        this.requestOptions = { ...this.requestOptions, ...options };
    }
    get options() {
        return this.requestOptions;
    }
    async putWithStatus(url, init) {
        const { baseUrl = "", fetch = globalThis.fetch, ...defaults } = this.options;
        const response = await fetch(baseUrl + url, {
            ...defaults,
            ...init,
            method: "PUT",
            headers: { ...defaults.headers, ...init.headers },
        });
        if (!response.ok)
            throw new ResponseError(response);
        const data = await response.json();
        return { data, status: response.status };
    }
    get(...args) {
        return super
            .get(...args)
            .then((data) => {
            // memdb doesn't send 4xx status code as error every time
            if ("error" in data) {
                throw new MemdbError(data.error.message, data.error.code);
            }
            return data;
        });
    }
    post = (url, init) => {
        const body = init?.body;
        const isObject = typeof body === "object" &&
            body instanceof Object &&
            !("FormData" in globalThis && body instanceof globalThis.FormData);
        return super.post(url, {
            ...init,
            body: isObject
                ? Object.entries(body)
                    .filter(([_, value]) => value !== undefined)
                    .map(([key, value]) => `${key}=${encodeURIComponent(typeof value === "object" ? JSON.stringify(value) : value)}`)
                    .join("&")
                : body,
            headers: isObject
                ? {
                    "content-type": "application/x-www-form-urlencoded",
                    ...init?.headers,
                }
                : init?.headers,
        });
    };
}
const MEMDB_URL = process.env.MEMDB_URL;
if (!MEMDB_URL) {
    throw new Error("env `MEMDB_URL` is not set");
}
export const memdbRequest = new MemdbRequest({
    baseUrl: `${MEMDB_URL}/api/v2`,
});
export const memdbRequestV3 = new MemdbRequest({
    baseUrl: `${MEMDB_URL}/api/v3`,
});
export class MemdbError extends Error {
    code;
    message;
    constructor(message, code) {
        super(message);
        // Hide custom error implementation details from end-users
        Error.captureStackTrace?.(this, this.constructor);
        this.code = code;
        this.message = message;
    }
}
export var MemdbErrorCode;
(function (MemdbErrorCode) {
    MemdbErrorCode[MemdbErrorCode["Unknown"] = 0] = "Unknown";
    MemdbErrorCode[MemdbErrorCode["InvalidAddress"] = 21] = "InvalidAddress";
    MemdbErrorCode[MemdbErrorCode["InvalidRole"] = 22] = "InvalidRole";
    MemdbErrorCode[MemdbErrorCode["RequiresAction"] = 31] = "RequiresAction";
    MemdbErrorCode[MemdbErrorCode["RequiresConfirmation"] = 32] = "RequiresConfirmation";
})(MemdbErrorCode || (MemdbErrorCode = {}));
export var MemdbBoolean;
(function (MemdbBoolean) {
    MemdbBoolean[MemdbBoolean["True"] = 1] = "True";
    MemdbBoolean[MemdbBoolean["False"] = -1] = "False";
})(MemdbBoolean || (MemdbBoolean = {}));
export const setAuthorization = (access_token) => {
    const headers = {
        ...memdbRequest.options?.headers,
        Authorization: `Bearer ${access_token}`,
    };
    if (!access_token) {
        // @ts-ignore
        headers.Authorization = undefined;
    }
    memdbRequest.options = { ...memdbRequest.options, headers };
    memdbRequestV3.options = { ...memdbRequestV3.options, headers };
};
//# sourceMappingURL=core.js.map